import React, { useState, useEffect } from 'react';
import AddressInputBlock from '../AddressInputBlock';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './sellerregispageblock1.module.css';
import { useTranslation } from "react-i18next";

const SellerRegisPageBlock1 = ({ onNext, updateData, formData }) => {
  const [showAddressInput, setShowAddressInput] = useState(false);
  const [addressInfo, setAddressInfo] = useState(formData.addressInfo || null);
  const [shopName, setShopName] = useState(formData.shopName || '');
  const [emailE, setEmailE] = useState(formData.emailE || '');
  const [phone, setPhone] = useState(formData.phone || '');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorEmailPhone, setErrorEmailPhone] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (formData.addressInfo) {
      setAddressInfo(formData.addressInfo);
    }
  }, [formData]);

  const handleAddressClick = (e) => {
    e.preventDefault();
    setShowAddressInput(true);
  };

  const handleSaveAddress = (data) => {
    setAddressInfo(data);
    setShowAddressInput(false);
  };

  const handleEditAddress = (e) => {
    e.preventDefault();
    setShowAddressInput(true);
  };

  const handleCancelAddress = () => {
    setShowAddressInput(false);
  };

  const handleNext = () => {
    if (showAddressInput) {
      setErrorMessage(t("fill_all_data"));
      return;
    }

    updateData({
      shopName,
      emailE,
      phone,
      addressInfo,
    });

    if (validateForm()) {
      setErrorMessage('');
      onNext();
    } else {
      setErrorMessage(t("fill_all_data"));
    }
  };

  const validateInput = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?[0-9]\d{9,14}$/;

    if (emailRegex.test(value) || phoneRegex.test(value) || value === '') {
      setErrorEmailPhone('');
    } else {
      setErrorEmailPhone(t("invalid_email_or_phone_1"));
    }
  };

  const validateForm = () => {
    return (
      shopName &&
      (emailE || phone) &&
      addressInfo &&
      !errorEmailPhone &&
      addressInfo.fullName &&
      addressInfo.phone &&
      addressInfo.address &&
      addressInfo.plusAddress &&
      addressInfo.selectedCity &&
      addressInfo.selectedDistrict &&
      addressInfo.selectedWard
    );
  };

  return (
    <div className={styles["block-container"]}>
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="mb-3 row">
        <label htmlFor="shopname" className="col-sm-2 col-form-label">{t("shop_name")}</label>
        <div className="col-sm-10">
          <input
            type="text"
            id="shopname"
            name="shopname"
            placeholder={t("enter_shop_name")}
            className="form-control"
            value={shopName}
            onChange={(e) => setShopName(e.target.value)}
            aria-label={t("shop_name")}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="field2" className="col-sm-2 col-form-label">{t("pickup_address")}</label>
        <div className="col-sm-10">
          {addressInfo ? (
            <div className="saved-address mb-3">
              <p>{addressInfo.fullName}</p>
              <p>{addressInfo.phone}</p>
              <p>{addressInfo.address}</p>
              <p>{addressInfo.plusAddress}</p>
              <a href="#" className="btn btn-link" onClick={handleEditAddress}>{t("edit")}</a>
            </div>
          ) : (
            <a href="#" onClick={handleAddressClick} className="btn btn-link">{t("select_address")}</a>
          )}
          {showAddressInput && <AddressInputBlock onSave={handleSaveAddress} onCancel={handleCancelAddress} initialAddress={addressInfo} />}
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="field3" className="col-sm-2 col-form-label">{t("email")}</label>
        <div className="col-sm-10">
          <input
            type="email"
            id="field3"
            name="field3"
            placeholder={t("enter_email")}
            className="form-control"
            value={emailE}
            onChange={(e) => {
              setEmailE(e.target.value);
              validateInput(e.target.value);
            }}
            aria-label={t("email")}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="field4" className="col-sm-2 col-form-label">{t("phone_number")}</label>
        <div className="col-sm-10">
          <input
            type="tel"
            id="field4"
            name="field4"
            placeholder={t("enter_phone_number")}
            className="form-control"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
              validateInput(e.target.value);
            }}
            aria-label={t("phone_number")}
          />
        </div>
      </div>
      {errorEmailPhone && <div className="alert alert-danger">{errorEmailPhone}</div>}
      <div className="d-flex justify-content-end">
        <button type="button" className="btn btn-success" onClick={handleNext}>{t("next")}</button>
      </div>
    </div>
  );
};

export default SellerRegisPageBlock1;
